'use client'

import { createContext, type ReactNode, useEffect, useState } from 'react'
import type { K2StaticLabels } from './static-labels-provider.types'

interface LabelContextValue {
  readonly labels: Partial<K2StaticLabels>
}

export const LabelContext = createContext<LabelContextValue | null>(null)

type LabelProviderProps = {
  children: ReactNode
  labels: Partial<K2StaticLabels>
}

export function StaticLabelsProvider({
  children,
  labels: passedLabels,
}: LabelProviderProps) {
  const [labels, setLabels] = useState<LabelProviderProps['labels']>(
    passedLabels ?? {},
  )

  useEffect(() => {
    setLabels((prevLabels) => ({ ...prevLabels, ...passedLabels }))
  }, [passedLabels])

  return (
    <LabelContext.Provider value={{ labels }}>{children}</LabelContext.Provider>
  )
}
